import { render, staticRenderFns } from "./edit-jianyanzu.vue?vue&type=template&id=221e13e9&scoped=true"
import script from "./edit-jianyanzu.vue?vue&type=script&lang=ts"
export * from "./edit-jianyanzu.vue?vue&type=script&lang=ts"
import style0 from "./edit-jianyanzu.vue?vue&type=style&index=0&id=221e13e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221e13e9",
  null
  
)

export default component.exports